// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.0.2",
  "buildDate": "2026-06-04T17:00:27.728Z"
};

export default buildInfo;
